if (!customElements.get('wi-free-shipping')) {
  class WatchItFreeShipping extends HTMLElement {
    connectedCallback() {
      this.onUpdate = () => queueMicrotask(() => this.update());
      this.scope = this.closest('.bls__product-details-infor');
      if (this.dataset.mode === 'product') {
        try {
          this.variants = JSON.parse(this.querySelector('[data-shipping-variants]').textContent);
        } catch {
          this.hidden = true;
          return;
        }
        this.scope?.addEventListener('change', this.onUpdate);
        this.scope?.addEventListener('click', this.onUpdate);
      }
      document.addEventListener('visitorConsentCollected', this.onUpdate);
      this.update();
    }

    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onUpdate);
      this.scope?.removeEventListener('click', this.onUpdate);
      document.removeEventListener('visitorConsentCollected', this.onUpdate);
    }

    update() {
      if (this.dataset.mode === 'product') {
        const form = document.getElementById(`product-form-${this.dataset.section}`);
        const id = form?.querySelector('[name="id"]')?.value || this.dataset.variant;
        let variant = this.variants.find(item => String(item.id) === String(id));
        const selector = this.scope?.querySelector('variant-selects');
        if (selector) {
          const options = Array.from(selector.querySelectorAll('.product-form__input'), field =>
            field.querySelector('.bls__option-swatch.active')?.dataset.value
          );
          if (options.length) {
            variant = this.variants.find(item => item.options.length === options.length &&
              item.options.every((value, index) => value === options[index]));
          }
        }
        this.hidden = !(this.dataset.country === 'US' && this.dataset.currency === 'USD' &&
          variant?.requires_shipping === true && Number(variant.price) > 5000);
      }
      this.trackView();
    }

    trackView() {
      if (this.hidden || this.tracked || this.dataset.track !== 'true') return;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      if (!Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({
        event: 'watch_it_free_shipping_view',
        placement: this.dataset.mode,
        experiment_version: 'free_shipping_visibility_v1',
        threshold_usd: 50
      });
      this.tracked = true;
    }
  }
  customElements.define('wi-free-shipping', WatchItFreeShipping);
}
